import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import { enqueueSnackbar } from 'notistack';

import { Spinner } from '@infoods/lifebase-ui';
import { angularizeWithProviders } from '../../providers';
import { apiStatusStore } from '../../stores/apiStatusStore';

const NgzApiStatus = observer(() => {
  const { isLoadingGlobal, errorMessage, cleanErrorMessage } = apiStatusStore;

  useEffect(() => {
    if (errorMessage) {
      enqueueSnackbar(errorMessage, { variant: 'error', onClose: cleanErrorMessage });
    }
  }, [errorMessage]);

  return <Spinner isLoading={isLoadingGlobal} isGlobal />;
});

angularizeWithProviders(NgzApiStatus, 'ngzApiStatus', {});

export { NgzApiStatus };
